// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubtaskTitle-module_subtask-title__jUF5L:not(:first-of-type){margin-top:25px}`, "",{"version":3,"sources":["webpack://./src/App/views/QuickAnswer/components/SubtaskTitle.module.scss"],"names":[],"mappings":"AAAA,8DAAmC,eAAe","sourcesContent":[".subtask-title:not(:first-of-type){margin-top:25px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtask-title": `SubtaskTitle-module_subtask-title__jUF5L`
};
export default ___CSS_LOADER_EXPORT___;
